import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {LocalPbxService} from '../local-pbx.service';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import {NotificationService} from '../../notification/notification.service';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { PbxGroupsGridComponent } from './grid/pbx-groups-grid.component';

@Component({
    selector: 'app-pbx-groups',
    templateUrl: './pbx-groups.component.html',
    styleUrls: ['./pbx-groups.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        GridFilterComponent,
        FilterRowAdditionalContentComponent,
        PbxGroupsGridComponent,
    ],
})
export class PbxGroupsComponent extends BaseComponent implements OnInit, OnDestroy {

  filterOptions: FilterOptionModel[] = [];
  filterChangeEvent = new EventEmitter<void>();

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title,
              public authService: AuthService,
              public pbxService: LocalPbxService,
              private notificationService: NotificationService,
              private router: Router
  ) {
    super(route, headerService, titleService, authService);

    this.editRoles = [RolesEnum.PbxGroups_Edit, RolesEnum.PbxGroups_Delete];
    this.deleteRoles = [RolesEnum.PbxGroups_Delete];
  }

  ngOnInit() {
    super.ngOnInit();
    this.headerService.hideSearchInput();
    this.initFilterOptions();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.headerService.hideSearchInput();
    this.headerService.searchText.next('');
  }

  navigateToDetails() {
    this.router.navigate(['new'], {relativeTo: this.route});
  }

  onFilterChanged(filter: any) {
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      {
        filterKey: 'account',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Account'
      },
      {
        filterKey: 'name',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Name'
      },
      {
        filterKey: 'accountTypes',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Agents Group',
        value: 'acds',
        searchText: 'Type: Agents Group',
      },
      {
        filterKey: 'accountTypes',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Hunt Group',
        value: 'hunts',
        searchText: 'Type: Hunt Group',
      },
    ];
  }
}
